import { render, staticRenderFns } from "./sellingPoints.vue?vue&type=template&id=200b6a2b&scoped=true"
import script from "./sellingPoints.vue?vue&type=script&lang=js"
export * from "./sellingPoints.vue?vue&type=script&lang=js"
import style0 from "./sellingPoints.vue?vue&type=style&index=0&id=200b6a2b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b6a2b",
  null
  
)

export default component.exports